import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class ZoomService {
  private zoomButtonVisibleSource = new BehaviorSubject<boolean>(true);
  private zoomLevelSource = new BehaviorSubject<number>(100);

  isPlanZoomButtonShown = this.zoomButtonVisibleSource.asObservable();
  /** Current zoom percentage (50–150, in 25% steps). Emits on every change and replays the latest value. */
  zoomLevel$ = this.zoomLevelSource.asObservable();

  setZoomLevel(percentage: number) {
    this.zoomLevelSource.next(percentage);
  }

  setPlanZoomButton(isVisible: boolean) {
    this.zoomButtonVisibleSource.next(isVisible);
  }
}
